import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: function(to) {
      return {
        path: '/pwd-login',
        query: to.query
      }
    }
  },
  {
    path: '/pwd-login',
    component: () => import('@/views/index.vue')
  },
  {
    path: '/sms-login',
    component: () => import('@/views/sms-login.vue')
  },
  {
    path: '/shortcut-login',
    component: () => import('@/views/shortcut-sms-login.vue')
  },
  {
    path: '/register',
    component: () => import('@/views/register.vue')
  },
  {
    path: '/register-verify',
    component: () => import('@/views/register-verify.vue')
  },
  {
    path: '/forget-pwd',
    component: () => import('@/views/forget-pwd.vue')
  },
  {
    path: '/forget-pwd-verify',
    component: () => import('@/views/forget-pwd-verify.vue')
  },
  {
    path: '/mobile-prefix-list',
    component: () => import('@/views/mobile-prefix-list.vue')
  },
  {
    path: '/protocol-detail',
    component: () => import('@/views/protocol-detail.vue')
  },
  {
    path: '/protocol-list',
    component: () => import('@/views/protocol-list.vue')
  },
  {
    path: '*',
    redirect: '@/views/404.vue',
    meta: { title: '404' }
  }
]

const router = new VueRouter({
  routes
})

export default router
